class ExpandableContent {
    constructor(container) {
        if (typeof container === 'string') {
            const found = document.querySelector(container);
            if (!found) {
                return;
            }
            this.container = found;
        }
        else {
            this.container = container;
        }
        this.init();
    }
    init() {
        const toggleButton = this.container.querySelector('[data-expandable-toggle]');
        const expandableList = this.container.querySelector('[data-expandable-list]');
        if (!toggleButton || !expandableList) {
            return;
        }
        toggleButton.addEventListener('click', (event) => {
            event.preventDefault();
            expandableList.querySelectorAll('.hidden').forEach((item) => {
                item.classList.remove('hidden');
                item.classList.add('expanded');
            });
            // Hide short-description by data attribute
            const shortDescription = expandableList.querySelector('[data-expandable-short]');
            if (shortDescription) {
                shortDescription.classList.add('hidden');
            }
            toggleButton.classList.add('hidden');
        });
    }
}
export default ExpandableContent;
